module.exports = __webpack_public_path__ + "static/media/logistics.fd43b6ae.png";